import styled from 'styled-components';
import * as Styles from './styles';

export const ExtendedTitle = styled(Styles.Titles)<{themeType: any}>`
  background: ${({themeType}) => (themeType ? '#000' : '#fff')} 
`;

export const ExtendedProfileHeader = styled(Styles.ProfileHeader)<{themeType: any}>`
background-color: ${({themeType}) => (themeType ? '#000' : '#fff')} ;
  h2 {
    color: ${({themeType}) => (themeType ? '#fff' : '#000')} ;
  }
  h4 {
    color: ${({themeType}) => (themeType ? '#fff' : '#000')} ;
  }  
`;